import { render, staticRenderFns } from "./QualityDisclaimer.vue?vue&type=template&id=8cacb14e&scoped=true&"
import script from "./QualityDisclaimer.vue?vue&type=script&lang=js&"
export * from "./QualityDisclaimer.vue?vue&type=script&lang=js&"
import style0 from "./QualityDisclaimer.vue?vue&type=style&index=0&id=8cacb14e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cacb14e",
  null
  
)

export default component.exports